let cn = {
  ALL: "全部",
  BIDDED: "已投标",
  NOBID: "未投标",
  BIDSUCCESS: "投标成功",
  BIDFAILED: "投标未成功",
  SEQNO: "条款编号",
  DESCRIPTION: "描述",
  REMARK: "备注",
  QUANTITY: "数量",
  UNITPRICE: "单价",
  LINETOTAL: "行总金额",
  TENDERNO: "招标编号",
  SUPPLIER: "供应商",
  TYPE: "招标类型",
  TEMPLAT: "招标模板",
  AMOUNT: "总金额",
  STATUS: "状态",
  DETAIL: "详细",
  ATTACHMENTS: "附件列表",
  ATTACHMENTID: "附件ID",
  ATTACHMENTTYPE: "附件类型",
  ATTACHMENTNAME: "附件名称",
  UPLOADATTACHMENT: "上传附件",
  ADDATTACHMENT: "添加附件",
  ADDING: "正在添加...",
  VIEWATTACHMENTS: "查看附件",
  RUNRPT:"打开单据",
  OPENING:"正在打开...",
  PRINT: "打印",
  LOADING: "正在加载...",
  REJECT_TIPS:"您将无法提交本次投标的任何价格，您确定要拒绝本次投标吗？",
  ACCEPT_TIPS:"投标邀请已被接受，请报价",
  REMARKTOSUPPLIER:"Remark To Supplier",
  SUPPLIERTOJLL:"Supplier Comments To JLL",
  SAVING_TIPS: "请确认您已经保存刚才输入的数据（保存按钮在页面的右下角），否则在上传附件后它们将不会被保存",
  TENDERCOLLECTVIATIPS:"This tender will be collected via Hard Copy only, therefore you are not able to upload any attachment. Submit or Decline can only be done in Hard Copy.",
};
let tw = {
  ALL: "全部",
  BIDDED: "已投標",
  NOBID: "未投標",
  BIDSUCCESS: "投標成功",
  BIDFAILED: "投標未成功",
  SEQNO: "條款編號",
  DESCRIPTION: "描述",
  REMARK: "備註",
  QUANTITY: "數量",
  UNITPRICE: "單價",
  LINETOTAL: "行總金額",
  TENDERNO: "招標編號",
  SUPPLIER: "供應商",
  TYPE: "招標類型",
  TEMPLAT: "招標模板",
  AMOUNT: "總金額",
  STATUS: "狀態",
  DETAIL: "詳細",
  ATTACHMENTS: "附件列表",
  ATTACHMENTID: "附件ID",
  ATTACHMENTTYPE: "附件類型",
  ATTACHMENTNAME: "附件名稱",
  UPLOADATTACHMENT: "上傳附件",
  ADDATTACHMENT: "添加附件",
  ADDING: "正在添加...",
  VIEWATTACHMENTS: "查看附件",
  RUNRPT:"打開單據",
  OPENING:"正在打開...",
  PRINT: "打印",
  LOADING: "正在加載...",
  REJECT_TIPS:"您將無法提交本次投標的任何價格，您確定要拒絕本次投標嗎？",
  ACCEPT_TIPS:"投標邀請已被接受，請報價",
  REMARKTOSUPPLIER:"Remark To Supplier",
  SUPPLIERTOJLL:"Supplier Comments To JLL",
  SAVING_TIPS: "請確認您已經保存剛才輸入的數據（保存按鈕在頁面的右下角），否則在上傳附件後它們將不會被保存",
  TENDERCOLLECTVIATIPS:"This tender will be collected via Hard Copy only, therefore you are not able to upload any attachment. Submit or Decline can only be done in Hard Copy.",
};
let en = {
  ALL: "All",
  BIDDED: "Bid",
  NOBID: "Nobid",
  BIDSUCCESS: "Success",
  BIDFAILED: "Failed",
  SEQNO: "Seq No.",
  DESCRIPTION: "Description",
  REMARK: "Remark",
  QUANTITY: "Quantity",
  UNITPRICE: "Unit Price",
  LINETOTAL: "Total Line Amount",
  TENDERNO: "Tender NO.",
  SUPPLIER: "Supplier Name",
  TYPE: "Tender Type",
  TEMPLAT: "Tender Templat",
  AMOUNT: "Total Amount",
  STATUS: "Status",
  DETAIL: "Detail",
  ATTACHMENTS: "Attachment List",
  ATTACHMENTID: "Attachment ID",
  ATTACHMENTTYPE: "Attachment Type",
  ATTACHMENTNAME: "Attachment Name",
  UPLOADATTACHMENT: "Upload Attachment",
  ADDATTACHMENT: "Add Attachment",
  ADDING: "Adding...",
  VIEWATTACHMENTS: "View Attachments",
  RUNRPT:"Open Document",
  OPENING:"Opening...",
  PRINT: "Print",
  LOADING: "Loading...",
  REJECT_TIPS:"You will not be able to submit any price for this tender, are you sure to reject this tender ?",
  ACCEPT_TIPS:"The invitation to bid has been accepted, please quote",
  REMARKTOSUPPLIER:"Remark To Supplier",
  SUPPLIERTOJLL:"Supplier Comments To JLL",
  SAVING_TIPS: "Please make sure you have saved the data you just entered (the Save button is in the lower right corner of the page), otherwise they will not be saved after uploading the attachment",
  TENDERCOLLECTVIATIPS:"This tender will be collected via Hard Copy only, therefore you are not able to upload any attachment. Submit or Decline can only be done in Hard Copy.",
}

export {
  cn,
  tw,
  en
}